import axios from "../../fetch-api/fetch-api";
import { IProductDeliveryMethodDetails } from "../interfaces/product-api.type";

export function getProductDeliveryDetailsSkuApi(sku: string, postalCode: string, quantity: number) {
  return axios.post<IProductDeliveryMethodDetails>("/get-customer-delivery-details-v3",
    { sku, postalCode, quantity });
}
